import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../services/guards/login-guard.guard';
import { OrdersReportComponent } from 'src/pages/orders-report/orders-report.component';
import { AventuraOsComponent } from './aventura-os/aventura-os.component';
import { ConfiguracionComponent } from './configuracion/configuracion.component';
import { DataPersonalRangoComponent } from './data-personal-rango/data-personal-rango.component';
import { ProgramacionAventuraComponent } from './programacion-aventura.component';
import { ProgramacionPersonalCampoComponent } from './programacion-personal-campo/programacion-personal-campo.component';
import { ProgramacionComponent } from './programacion/programacion.component';
import { ReportePersonalCampoComponent } from './reporte-personal-campo/reporte-personal-campo.component';
import { FileProgrammingComponent } from 'src/pages/file-programming/file-programming.component';

const routes: Routes = [
  {
    path: '',
    component: ProgramacionAventuraComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: ProgramacionComponent },
      {
        path: 'programacion-personal-campo',
        canActivate: [AuthGuard],
        component: ProgramacionPersonalCampoComponent
      },
      {
        path: ':location/programacion-personal-campo',
        canActivate: [AuthGuard],
        component: ProgramacionPersonalCampoComponent
      },
      {
        path: 'aventura-os',
        canActivate: [AuthGuard],
        component: AventuraOsComponent
      },
      {
        path: ':location/aventura-os',
        canActivate: [AuthGuard],
        component: AventuraOsComponent
      },

      {
        path: 'reporte-personal-campo',
        canActivate: [AuthGuard],
        component: ReportePersonalCampoComponent
      },
      {
        path: ':location/reporte-personal-campo',
        canActivate: [AuthGuard],
        component: ReportePersonalCampoComponent
      },
      {
        path: 'programacion',
        canActivate: [AuthGuard],
        component: FileProgrammingComponent
      },
      {
        path: ':location/configuracion',
        canActivate: [AuthGuard],
        component: ConfiguracionComponent
      },
      {
        path: 'DataPersonalRango',
        canActivate: [AuthGuard],
        component: DataPersonalRangoComponent
      },
      {
        path: ':location/DataPersonalRango',
        canActivate: [AuthGuard],
        component: DataPersonalRangoComponent
      },
      {
        path: 'ordenes',
        canActivate: [AuthGuard],
        component: OrdersReportComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramacionAventuraRoutingModule {}
